import { KeyboardArrowLeftOutlined, KeyboardArrowRightOutlined } from '@mui/icons-material';
import { useConsultDoctorContext } from '../../Contexts/ConsultDoctorContext';
import ErrorComponent from '../../Components/ErrorComponent';
import SpecializationContent from './SpecializationContent';
import DatePicker from '../../Components/DatePicker';
import { CircularProgress } from '@mui/material';
import TimesContent from './TimesContent';
import { Fragment } from 'react';
import dayjs from 'dayjs';

function DateContent() {

    const {
        setSelectedDoctorBySearch,
        setAllDoctorsFromBranch,
        setShowDoctorsModal,
        setToSearchByDoctor,
        setSelectedDoctor,
        getSpecialization,
        toSearchByDoctor,
        setSelectedTime,
        setSelectedDate,
        setSearchDoctor,
        availableDates,
        selectedDate,
        loadState,
        setMonth,
        setYear
    } = useConsultDoctorContext();

    const handleSelectDate=(date)=>{
        if(date){
            setSelectedDate(dayjs(date).format("YYYY-MM-DD"))
        }
    }

    const toSorted = (dates) => {
        if (!dates) return [];
        return dates.sort((a, b) =>
            dayjs(a.date).isAfter(dayjs(b.date)) ? 1 : -1
        );
    };

    const nextDay = async () => {
        const sortedDates = toSorted(availableDates);
        const index = sortedDates.findIndex(e=>e.date === selectedDate);
        if(index>=0){
            const nextDay = sortedDates[index + 1]?.date || dayjs(sortedDates[index]).add(1, 'day').format("YYYY-MM-DD");
            const lastDay = sortedDates[sortedDates.length - 1]?.date;
            if (dayjs(nextDay).isSame(lastDay) || dayjs(nextDay).isBefore(lastDay)) {
                setSelectedDate(nextDay);
                //remove selected doctor and time when changing date
                setSelectedDoctor();
                setSelectedTime();
            }
        }
    };

    const nextValid = () => {
        const sortedDates = toSorted(availableDates);
        const index = sortedDates.findIndex(e=>e.date === selectedDate);
        if(index>=0){
            const nextDay = sortedDates[index + 1]?.date || dayjs(sortedDates[index]).add(1, 'day').format("YYYY-MM-DD");
            const lastDay = sortedDates[sortedDates.length - 1]?.date;
            return dayjs(nextDay).isSame(lastDay) || dayjs(nextDay).isBefore(lastDay)
        }else{
            return false;
        }
    };

    const previousDay = async () => {
        const sortedDates = toSorted(availableDates);
        const index = sortedDates?.findIndex(
            ({ date }) => date === dayjs(selectedDate).format("YYYY-MM-DD")
        );
        if (index > 0) {
            setSelectedDate(
                dayjs(sortedDates[index - 1].date).format("YYYY-MM-DD")
            );
            //remove selected doctor and time when changing date
            setSelectedDoctor();
            setSelectedTime();
        }
    };

    const prevValid = () => {
        const sortedDates = toSorted(availableDates);
        const index = sortedDates?.findIndex(
            ({ date }) => date === dayjs(selectedDate).format("YYYY-MM-DD")
        );
        return index > 0;
    };

    const handleChangeSearch = () => {
        setToSearchByDoctor(!toSearchByDoctor);
        setSelectedDoctorBySearch(null);
        setSelectedDoctor();
        setSelectedTime();
        setSearchDoctor("");

        if(!toSearchByDoctor){
            setShowDoctorsModal(true);

            //reset doctors list
            setAllDoctorsFromBranch([]);
        }
    };

    const handleKeyDown = (event, callback) => {
        if (event.key === "Enter" || event.key === " ") {
            callback();
        }
    };

    const getNextPrevClassName=(str, condition)=>{
        if(condition){
            str = str + " bg-[#ebebeb]"
        }
        return str;
    }

    const isPrevDisabled = !selectedDate || !prevValid();
    const isNextDisabled = !selectedDate || !nextValid();

    let searchStr = "Looking for a specific doctor?"
    if(toSearchByDoctor){
        searchStr = "Looking for a specialization?"
    }

    let content = null;

    if (loadState === "get specializations") {
        content = (
            <div className="w-full flex justify-center items-center mt-4 mb-2">
                <CircularProgress />
            </div>
        );
    } else if (
        [
            "get specializations ISE",
            "get specializations retry",
            "get specializations timeout",
        ].includes(loadState)
    ) {
        content = (
            <ErrorComponent
                onRetry={() => getSpecialization("get specializations retry")}
                isLoading={loadState === "get specializations retry"}
            />
        );
    } else {
        content = (
        <Fragment>
            <SpecializationContent/>
            <div className="flex flex-row">
                <div className="w-full mr-2">
                    <DatePicker
                        disablePast={true}
                        value={selectedDate ? dayjs(selectedDate) : null}
                        onAccept={(date) => handleSelectDate(date)}
                        onMonthChange={(value) => {
                            setMonth(dayjs(value).format("MM"));
                        }}
                        onYearChange={(value) => {
                            setYear(dayjs(value).format("YYYY"));
                        }}
                        shouldDisableDate={(date) =>
                            !availableDates?.some(
                                (item) => item.date === dayjs(date).format("YYYY-MM-DD")
                            )
                        }
                    />
                </div>
                <div className="flex ml-auto">
                    <button
                        disabled={isPrevDisabled}
                        className={getNextPrevClassName(
                            "flex flex-col items-center border rounded flex-grow p-2 mr-2",
                            isPrevDisabled
                        )}
                        onClick={previousDay}
                        >
                        <KeyboardArrowLeftOutlined
                            className="mt-1"
                            style={{
                            fontSize: 18,
                            fill: `${isPrevDisabled ? "#bebebe" : "#000"}`,
                            }}
                        />
                    </button>
                    <button
                        disabled={isNextDisabled}
                        className={getNextPrevClassName(
                            "flex flex-col items-center border rounded flex-grow p-2",
                            isNextDisabled
                        )}
                        onClick={nextDay}
                        >
                        <KeyboardArrowRightOutlined
                            className="mt-1"
                            style={{
                            fontSize: 18,
                            fill: `${isNextDisabled ? "#bebebe" : "#000"}`,
                            }}
                        />
                    </button>
                </div>
            </div>

            <div className="flex flex-row mt-2 pb-2">
                <div className="text-sm text-[#60656D]">
                    {searchStr}
                    <button
                        className=" text-[#0947AB] text-sm ml-1 cursor-pointer"
                        onClick={handleChangeSearch}
                        onKeyDown={(event) =>
                            handleKeyDown(event, () => handleChangeSearch)
                        }
                    >
                    Search here
                    </button>
                </div>
            </div>
            <TimesContent/>
        </Fragment>
        );
    }

    return content;
}

export default DateContent